import { createContext } from "react";

type role = string;

const defaultValue: [role] = [""];

const RoleContext = createContext(defaultValue);

export default RoleContext;
